import api from './index';

const BASE = '/bidding-calculated';

export const getBiddingCalculated = async ({
    dateFrom,
    dateTo,
    workingUnitLocation,
    released,
}: {
    dateFrom: string;
    dateTo: string;
    workingUnitLocation: number;
    released?: boolean;
}) => {
    return api.get(BASE, { params: { dateFrom, dateTo, workingUnitLocation, released } }).then((res) => res.data);
};

export const getBiddingCalculatedResults = async ({
    dateFrom,
    dateTo,
    workingUnitLocation,
}: {
    dateFrom: string;
    dateTo: string;
    workingUnitLocation: number;
}) => {
    return api.get(`${BASE}/result`, { params: { dateFrom, dateTo, workingUnitLocation } }).then((res) => res.data);
};

export const getLastBiddingCalculationDate = async ({ workingUnitLocation }: { workingUnitLocation: number }) => {
    return api.get(`${BASE}/last-calculation`, { params: { workingUnitLocation } }).then((res) => res.data);
};

export const releaseTotals = async ({
    dateFrom,
    dateTo,
    locations,
    workingUnits,
    isSubsequentRelease,
}: {
    dateFrom: string;
    dateTo: string;
    locations: number[];
    workingUnits: number[];
    isSubsequentRelease: boolean;
}) => {
    return api
        .post(`${BASE}/release-totals`, { dateFrom, dateTo, locations, workingUnits, isSubsequentRelease })
        .then((res) => res.data);
};

export const getLastBiddingCalculatedTotalsReleaseDate = async ({
    workingUnitLocation,
}: {
    workingUnitLocation: number;
}) => {
    return api.get(`${BASE}/last-totals-release`, { params: { workingUnitLocation } }).then((res) => res.data);
};

export const getSumOfReleasedBiddingCalculatedTotals = async ({
    dateFrom,
    dateTo,
    workingUnitLocation,
}: {
    dateFrom: string;
    dateTo: string;
    workingUnitLocation: number;
}) => {
    return api.get(`${BASE}/totals-sum`, { params: { dateFrom, dateTo, workingUnitLocation } }).then((res) => res.data);
};

export const calculateBidding = async ({ date, workingUnits }: { date: string; workingUnits: number[] }) => {
    return api
        .get(`${BASE}/calculate`, { params: { date, workingUnits } })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
};

export const createBiddingCalculatedTotals = async (data: any) => {
    return api.post(BASE, { data }).then((res) => res.data);
};
